import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import YoutubePlayer from '../../components/youtube-player';
import './styles.css';
import PhotoInfo from "../photo-info";

export default class SlidegalleryItem extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    pcSrc: PropTypes.string,
    mbSrc: PropTypes.string,
    youtubeId: PropTypes.string,
    thumbnailSrc: PropTypes.string,
    photoInfo: PropTypes.arrayOf(PropTypes.node),
    getRef: PropTypes.func,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    pcSrc: null,
    mbSrc: null,
    videoSrc: null,
    youtubeId: null,
    thumbnailSrc: null,
    photoInfo: null,
    getRef: null,
  };
  
  constructor(props) {
    super(props);
    this.photoInfo = null;
    if (this.props.getRef) this.props.getRef(this);
    //
    this.state = {
      isOpenPhotoInfo: false
    }
  }
  
  render() {
    const {
      containerId,
      containerClass,
      pcSrc,
      mbSrc,
      youtubeId,
      thumbnailSrc,
      photoInfo,
    } = this.props;
    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <div className="SlidegalleryItem">
          {(() => {
            if (youtubeId !== null && youtubeId !== '') {
              if (this.props.current === true) {
                return (
                  <div className="SlidegalleryItem__video-wrapper">
                    <YoutubePlayer
                      height={585}
                      width={1040}
                      autoplay={0}
                      controls={0}
                      youtubeId={youtubeId}
                      onReady={(e) => {
                        //console.log('onReady');
                      }}
                      onStateChange={(e) => {
                        //console.log('onStateChange');
                      }}
                    />
                    <div className="SlidegalleryItem__photo-info-wrapper">
                      {/*{(photoInfo !== null && 1 <= photoInfo.length) ? photoInfo: null}*/}
                      {(photoInfo !== null && 1 <= photoInfo.length) ?
                        <PhotoInfo {...photoInfo[0].props}
                                   isOpen={this.state.isOpenPhotoInfo}
                        />
                      : null}
                    </div>
                  </div>
                )
              } else {
                return (
                  <div className="SlidegalleryItem__video-wrapper"/>
                )
              }
            } else {
              return (
                <div className="SlidegalleryItem__image-wrapper">
                  {(() => {
                    if (pcSrc !== null && pcSrc !== '') {
                      return (
                        <div className="SlidegalleryItem__image-pc"
                             style={{backgroundImage: 'url(' + pcSrc + ')'}}
                        />
                      )
                    }
                  })()}
                  {(() => {
                    let src = null;
                    if (mbSrc !== null && mbSrc !== '') {
                      src = mbSrc;
                    } else {
                      src = pcSrc;
                    }
                    if (src !== null && src !== '') {
                      return (
                        <div className="SlidegalleryItem__image-mb"
                             style={{backgroundImage: 'url(' + src + ')'}}
                        />
                      )
                    }
                  })()}
                  {/*{(photoInfo !== null && 1 <= photoInfo.length) ? photoInfo: null}*/}
                  {(photoInfo !== null && 1 <= photoInfo.length) ?
                    <PhotoInfo {...photoInfo[0].props}
                               isOpen={this.state.isOpenPhotoInfo}
                    />
                    : null}
                </div>
              )
            }
          })()}
        </div>
      </Wrapper>
    );
  }
  
  initialize = ()=> {
    if (this.photoInfo) {
      this.setState({
        isOpenPhotoInfo: false
      })
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/containers/slidegallery-item/index.jsx